import LandingPage from '@/components/LandingPage';
import type { Route } from './+types/home';

export function meta({}: Route.MetaArgs) {
  return [
    { title: 'Gamified Cybersecurity Training Platform | SimulationsLabs' },
    {
      name: 'description',
      content:
        'Simulations Labs is a no-code platform, offering entities and individuals the power to build labs and CTF competitions effortlessly with access to a comprehensive challenge library.',
    },
  ];
}

export default function Home() {
  return <LandingPage />;
}
